<template>
	<div>
		<div ref="markerHtml">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	import { gmapApi } from 'vue2-google-maps';
	import * as VueGoogleMaps from 'vue2-google-maps';
	import RichMarker from 'googlemaps-rich-marker-web';

	export default VueGoogleMaps.MapElementFactory({
		mappedProps: {
			options: {
				type: Object,
				required: false,
				default() {
					return {};
				},
			},
			flat: {
				type: Boolean,
				default: true,
			},
			position: {
				type: Object,
				twoWay: true,
			},
			anchor: {
				default: 8,
			},
		},
		computed: {
			google: gmapApi,
		},
		events: ['click', 'ready', 'content_changed'],
		name: 'richMarker',
		ctr: () => RichMarker.RichMarker,
		inject: {
			$markerPromise: { default: null },
		},
		mounted() {
			const el = this.$refs.markerHtml;
			el.parentNode.removeChild(el);
		},
		beforeCreate(_options) {
			const options = _options;
			options.content = this.$refs.markerHtml;
			if (this.$markerPromise) {
				delete options.position;
				return this.$markerPromise.then((mo) => {
					this.$markerObject = mo;
					return mo;
				});
			}
			return null;
		},
	});
</script>
